<span class="container">{{text}}<span class="overlay">{{text}}</span></span>
